export default "__VITE_ASSET__CCTASFmE__"